<app-header (menuOpen)="menuOpen = true"></app-header>
<app-menu></app-menu>
<div class="pt-5">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<app-banner-cookies *ngIf="isBrowser"></app-banner-cookies>


  <div #stickyDettaglio class="add-cart-section d-md-none" *ngIf="showDettaglioMobileSticky">
    <div class="container">
      <div class="row">
        <div class="col-12 mb-3 text-center">
          <button title="{{'AGGIUNGI_AL_CARRELLO' | translate}}" class="btn btn-stem" type="button" [disabled]="aggiungCarrelloDisabledDettaglioMobileSticky" (click)="aggiungiCarrello()">
            <span><i class="fas fa-shopping-cart"></i></span> <span> {{'AGGIUNGI_AL_CARRELLO' | translate}}</span>
          </button>
        </div>
      </div>
      <div class="row" *ngIf="showConfiguraDettaglioMobileSticky">
        <div class="col-12 text-center">
          <a appHref="/configuratore">
            <button class="btn btn-stem btn-alt" type="button" title="{{'CONFIGURA_IL_TUO_PRODOTTO' | translate | htmlToText}}">
              <span>{{'CONFIGURA_IL_TUO_PRODOTTO' | translate | htmlToText}}</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>


<app-modals></app-modals>